import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getColumnsWidthStyles } from 'app/pages/loanApplication/LoanApplication.sharedStyles';
import LoanTabLayout from 'app/pages/loanApplication/LoanTabLayout';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { selectLoanBundleHistorySortedByDate } from 'store/loanApplications/selectors';

import LoanBundleHistoryContent from './LoanBundleHistoryContent';

const LoanBundleHistory = ({ isLoading }) => {
  const theme = useTheme();
  const columnsStyles = useMemo(() => getColumnsWidthStyles(theme, { columns: 3 }), [theme]);

  const loanBundleHistorySorted = useSelector(selectLoanBundleHistorySortedByDate);

  const isEmptyContentPlaceholder = !isLoading && !loanBundleHistorySorted?.length;

  return (
    <>
      <Typography gutterBottom className="mb-12 mt-24" component="div" variant="bold16">
        Form Delivery
      </Typography>
      <LoanTabLayout
        isLightBackgroundLayout
        content={<LoanBundleHistoryContent loanBundleHistorySorted={loanBundleHistorySorted} />}
        id="form-bundle-history-section"
        isEmptyContentPlaceholder={isEmptyContentPlaceholder}
        top={
          <Box className="w-full flex pr-48" sx={columnsStyles.wrapper}>
            <Typography variant="medium16">Form Bundle</Typography>
            <Typography variant="medium16">Date sent</Typography>
            <Typography variant="medium16">E-Signed</Typography>
            <Typography variant="medium16">Acknowledged</Typography>
          </Box>
        }
      />
    </>
  );
};

LoanBundleHistory.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default compose(memo)(LoanBundleHistory);
